// src/lib/appointment/status.ts
export const AppointmentStatus = Object.freeze({
  WAITING: "waiting",
  CONFIRMED: "confirmed",
  ARRIVED_PAID: "arrived_paid",
  ARRIVED_UNPAID: "arrived_unpaid",
  NO_SHOW: "no_show",
} as const);

export type AppointmentStatus =
  typeof AppointmentStatus[keyof typeof AppointmentStatus];
